import { InterestMessage as InterestMessageResponse } from "../../api/HomePageResponseTypes";
import { DateString } from "../../util/conversionUtils";

export interface InterestMessage extends Omit<InterestMessageResponse, "tahtaeg"> {
  tahtaeg: DateString;
}

export enum ColumnHeader {
  proceedingNr = "proceedingNr",
  manager = "manager",
  due = "due",
  content = "content",
}
